module.exports = __webpack_public_path__ + "static/media/Price 1.f900c295.svg";